const environments ={
    squareAppID: "sandbox-sq0idb-OkEiLAEVOCT8CwRO2POjIg"
}

export default environments